module.exports = __webpack_public_path__ + "img/zoom.0829f4b4.png";